import { createContext, useContext } from "react";
import { type GameData } from "app/game-data/useFetchGameData";
export const GameDataContext = createContext<GameData | undefined>(undefined);

export default function useGameData(): GameData | undefined {
  return useContext(GameDataContext);
}
